// Mock data for JLEE website
// IMPORTANT: All music links must point to:
// - SoundCloud: https://on.soundcloud.com/p7lR72fb7GYKSPuCUZ (artist profile)
// - Apple Music: https://music.apple.com/ca/artist/jlee/1756341411 (artist profile)
// Artwork should come from actual release artwork (SoundCloud CDN or Apple Music)

export const artistInfo = {
  name: "JLEE",
  realName: "Jessie Lawrence",
  tagline: "Independent Music Artist",
  bio: "JLEE is an independent music artist from Kelowna, British Columbia, Canada. Focused on studio releases and online distribution, JLEE creates electronic music available on SoundCloud and Apple Music. This is all a figment of your imagination.",
  location: "Kelowna, British Columbia, Canada",
  locationShort: "Kelowna, BC",
  genres: ["Electronic", "Dubstep", "Bass Music", "Chill", "Ambient"],
  email: "JLEE.DUBSTEP@gmail.com",
  instagram: "@jleemusic.kelowna",
  website: "jleemusic.ca",
  soundcloudUrl: "https://on.soundcloud.com/p7lR72fb7GYKSPuCUZ",
  appleMusicUrl: "https://music.apple.com/ca/artist/jlee/1756341411",
  soundcloudFollowers: "44",
  totalTracks: "7",
  profileImage: "/jlee3.png"
};

// Mock SoundCloud tracks (fallback data - always shown first)
// These tracks are from: https://soundcloud.com/jessie-lawrence-103169919
// Note: Individual track URLs will be fetched from backend, but these serve as fallback
export const mockSoundCloudTracks = [
  {
    id: 'sc_andariel',
    title: 'Andariel',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/andariel',
    artwork_url: 'https://i1.sndcdn.com/artworks-1nm6Yb4qPwXK1yYy-cpSubg-t500x500.png',
    playback_count: 163,
    genre: 'Dubstep',
    created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(), // 2 weeks ago (relative to now)
    platform: 'SoundCloud'
  },
  {
    id: 'sc_sound_blast',
    title: 'Sound Blast',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/sound-blast',
    artwork_url: '/jlee3.png',
    playback_count: 229,
    genre: 'Dubstep',
    created_at: '2024-10-22T14:30:00Z',
    platform: 'SoundCloud'
  },
  {
    id: 'sc_aurora',
    title: 'Aurora',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/aurora',
    artwork_url: '/jlee3.png',
    playback_count: 191,
    genre: 'Dubstep',
    created_at: '2024-10-08T16:45:00Z',
    platform: 'SoundCloud'
  },
  {
    id: 'sc_bang_bang',
    title: 'Bang bang',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/bang-bang',
    artwork_url: '/jlee3.png',
    playback_count: 19,
    genre: 'Dubstep',
    created_at: '2024-11-18T10:20:00Z',
    platform: 'SoundCloud'
  },
  {
    id: 'sc_intro',
    title: 'intro',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/intro',
    artwork_url: '/jlee3.png',
    playback_count: 10,
    genre: 'Dubstep',
    created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 1 month ago
    platform: 'SoundCloud'
  },
  {
    id: 'sc_slacking',
    title: 'Slacking',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/slacking',
    artwork_url: '/jlee3.png',
    playback_count: 0,
    genre: 'Dubstep',
    created_at: '2023-06-14T11:00:00Z',
    platform: 'SoundCloud'
  },
  {
    id: 'sc_sweetie',
    title: 'Sweetie',
    permalink_url: 'https://soundcloud.com/jessie-lawrence-103169919/sweetie',
    artwork_url: '/jlee3.png',
    playback_count: 28,
    genre: 'Dubstep',
    created_at: '2020-03-25T13:30:00Z',
    platform: 'SoundCloud'
  }
];

export const releases = [
  {
    id: 1,
    title: "Skipping Class - EP",
    type: "EP",
    year: "2024",
    // Artwork from Apple Music: https://music.apple.com/ca/album/skipping-class-ep/1758911264
    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/f6/82/39/f6823929-80fc-d6e7-d6fe-24c5143b5087/752470184024_cover.jpg/1200x1200bb.jpg",
    appleMusicUrl: "https://music.apple.com/ca/album/skipping-class-ep/1758911264",
    soundcloudUrl: "https://on.soundcloud.com/p7lR72fb7GYKSPuCUZ",
    platform: "Apple Music & SoundCloud",
    trackCount: 4,
    tracks: [
      { name: "Summer Rain" },
      { name: "Homework" },
      { name: "Skipping Class" },
      { name: "Midnight Munchies" }
    ]
  },
  {
    id: 2,
    title: "Andariel",
    type: "Single",
    year: "2024",
    genre: "Dubstep",
    plays: "163",
    coverImage: "https://i1.sndcdn.com/artworks-1nm6Yb4qPwXK1yYy-cpSubg-t500x500.png",
    soundcloudUrl: "https://on.soundcloud.com/p7lR72fb7GYKSPuCUZ",
    appleMusicUrl: "https://music.apple.com/ca/artist/jlee/1756341411",
    platform: "SoundCloud & Apple Music"
  },
  {
    id: 3,
    title: "Somber",
    type: "Single",
    year: "2024",
    // Artwork from Apple Music: https://music.apple.com/ca/album/somber-single/1758927943
    coverImage: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/a3/b9/65/a3b9655d-a7de-965f-daaf-32c44d581ca7/730530550880_cover.jpg/1200x1200bb.jpg",
    appleMusicUrl: "https://music.apple.com/ca/album/somber-single/1758927943",
    soundcloudUrl: "https://on.soundcloud.com/p7lR72fb7GYKSPuCUZ",
    platform: "Apple Music & SoundCloud"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/f6/82/39/f6823929-80fc-d6e7-d6fe-24c5143b5087/752470184024_cover.jpg/1200x1200bb.jpg",
    alt: "Skipping Class EP artwork",
    caption: "Skipping Class - EP"
  },
  {
    id: 2,
    url: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/a3/b9/65/a3b9655d-a7de-965f-daaf-32c44d581ca7/730530550880_cover.jpg/1200x1200bb.jpg",
    alt: "Somber single artwork",
    caption: "Somber"
  },
  {
    id: 3,
    url: "https://i1.sndcdn.com/artworks-1nm6Yb4qPwXK1yYy-cpSubg-t500x500.png",
    alt: "Andariel artwork",
    caption: "Andariel"
  }
];

export const testimonials = [];

export const socialLinks = [
  { platform: "soundcloud", url: "https://on.soundcloud.com/p7lR72fb7GYKSPuCUZ", icon: "Music", label: "SoundCloud" },
  { platform: "apple-music", url: "https://music.apple.com/ca/artist/jlee/1756341411", icon: "Music2", label: "Apple Music" },
  { platform: "instagram", url: "https://instagram.com/jleemusic.kelowna", icon: "Instagram", label: "Instagram" }
];